var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordVoiceOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "record_voice_over"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1283_319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1283_319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "record_voice_over_2",
    d: "M9.97549 7.97539L9.20049 7.20039C9.56715 6.85873 9.85465 6.45456 10.063 5.98789C10.2713 5.52122 10.3755 5.02539 10.3755 4.50039C10.3755 3.97539 10.2713 3.48372 10.063 3.02539C9.85465 2.56706 9.56715 2.16706 9.20049 1.82539L9.97549 1.02539C10.4422 1.46706 10.813 1.98789 11.088 2.58789C11.363 3.18789 11.5005 3.82539 11.5005 4.50039C11.5005 5.17539 11.363 5.81289 11.088 6.41289C10.813 7.01289 10.4422 7.53373 9.97549 7.97539ZM8.37549 6.37539L7.57549 5.57539C7.72549 5.43372 7.84632 5.27331 7.93799 5.09414C8.02965 4.91497 8.07549 4.71706 8.07549 4.50039C8.07549 4.28372 8.02965 4.08581 7.93799 3.90664C7.84632 3.72747 7.72549 3.56706 7.57549 3.42539L8.37549 2.62539C8.64215 2.86706 8.85049 3.14831 9.00049 3.46914C9.15049 3.78997 9.22549 4.13372 9.22549 4.50039C9.22549 4.86706 9.15049 5.21081 9.00049 5.53164C8.85049 5.85247 8.64215 6.13372 8.37549 6.37539ZM4.50049 6.50039C3.95049 6.50039 3.47965 6.30456 3.08799 5.91289C2.69632 5.52122 2.50049 5.05039 2.50049 4.50039C2.50049 3.95039 2.69632 3.47956 3.08799 3.08789C3.47965 2.69622 3.95049 2.50039 4.50049 2.50039C5.05049 2.50039 5.52132 2.69622 5.91299 3.08789C6.30465 3.47956 6.50049 3.95039 6.50049 4.50039C6.50049 5.05039 6.30465 5.52122 5.91299 5.91289C5.52132 6.30456 5.05049 6.50039 4.50049 6.50039ZM0.500488 10.5004V9.10039C0.500488 8.82539 0.571322 8.56706 0.712988 8.32539C0.854655 8.08372 1.05049 7.90039 1.30049 7.77539C1.72549 7.55872 2.20465 7.37539 2.73799 7.22539C3.27132 7.07539 3.85882 7.00039 4.50049 7.00039C5.14215 7.00039 5.72965 7.07539 6.26299 7.22539C6.79632 7.37539 7.27549 7.55872 7.70049 7.77539C7.95049 7.90039 8.14632 8.08372 8.28799 8.32539C8.42965 8.56706 8.50049 8.82539 8.50049 9.10039V10.5004H0.500488Z",
    fill: "#196CCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordVoiceOver);
export default __webpack_public_path__ + "static/media/record_voice_over.6e3af41de394ea0ac66b57dca1952a42.svg";
export { ForwardRef as ReactComponent };